import React from 'react';
import { Spinner, Frame, Text, BlockStack } from '@shopify/polaris';
import './Loading.css'; // We can reuse the same CSS

const AuthRedirect = ({ shop }) => {
  return (
    <Frame>
      <div className="loading-container">
        <BlockStack gap="400" alignment="center">
          <div className="spinner-wrapper">
            <Spinner size="large" accessibilityLabel="Redirecting" hasFocusableParent={false} />
          </div>
          <Text variant="headingMd" as="h4">
            Redirecting to Shopify auth...
          </Text>
          <Text variant="bodyMd" as="p" color="subdued">
            Store: {shop}
          </Text>
        </BlockStack>
      </div>
    </Frame>
  );
};

export default AuthRedirect; 